import { Observable } from './zenObservable';
export * from './zenObservable';
export default Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/zen-observable-ts/lib/index.js
// module id = 165
// module chunks = 0